module.exports = __webpack_public_path__ + "static/media/MT.42376123.svg";